import { Component, OnInit } from '@angular/core';

import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Fields } from 'src/app/shared/models/candidateprofile-genmodel';

@Component({
  selector: 'app-phonenumber',
  templateUrl: './phonenumber.component.html',
  styleUrls: ['./phonenumber.component.scss'],
  standalone: false,
})
export class PhonenumberComponent implements OnInit {
  field: Fields;
  group: UntypedFormGroup;
  phoneGroup: any;

  codeControl = new UntypedFormControl('');
  countryCode = {
    name: 'country_code',
    displayName: 'Code',
    inputType: 'text',
    value: null,
    validations: [
      {
        name: 'required',
        value: 'required',
        message: 'required',
      },
      {
        name: 'pattern',
        value: '^[0-9]{1,5}$',
        message: 'invalid',
      },
    ],
  };

  constructor() {}

  ngOnInit() {
    this.codeControl.setValidators(this.bindValidations());
    this.group.addControl('country_code', this.codeControl);
    this.group.get('country_code').valueChanges.subscribe((data) => {
      this.field.validations.forEach((validations) => {
        if (validations.name == 'pattern') {
          if (data == 91) {
            validations.value = '^[1-9][0-9]{9,9}$';
            this.group.controls['primary_contact_no'].setValidators([
              Validators.required,
              Validators.pattern('^[1-9][0-9]{9,9}$'),
            ]);
          } else {
            validations.value = '^[1-9][0-9]{8,14}$';
            this.group.controls['primary_contact_no'].setValidators([
              Validators.required,
              Validators.pattern('^[1-9][0-9]{8,14}$'),
            ]);
          }
        }
      });
    });
  }

  bindValidations() {
    if (this.countryCode.validations.length > 0) {
      const validList = [];
      this.countryCode.validations.forEach((valid) => {
        switch (valid.name) {
          case 'required': {
            validList.push(Validators.required);
            break;
          }
          case 'pattern': {
            validList.push(Validators.pattern(valid.value));
            break;
          }
        }
      });
      return Validators.compose(validList);
    }
  }
}
